import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-administrador-informacion-inicial',
  templateUrl: './administrador-informacion-inicial.component.html',
  styleUrls: ['./administrador-informacion-inicial.component.scss']
})
export class AdministradorInformacionInicialComponent {

  constructor(public authService: AuthService) { }
}
